import { Component, Input, OnInit } from '@angular/core';
import { faEnvelope, faUser } from '@fortawesome/pro-duotone-svg-icons';
import { Select, Store } from '@ngxs/store';
import { iif, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SamwinMessageListStateSelectors } from 'src/app/store/samwin/samwin-mail-list/samwin-message-list.selectors';
import { MailingFolderEnum } from 'src/app/store/samwin/samwin-skills/mailing-folders-enum';
import { MailingSkillTreeItem } from 'src/app/store/samwin/samwin-skills/mailing-skill-tree-item';
import { SamwinSkillTypeEnum } from 'src/app/store/samwin/samwin-skills/samwin-skills-type-enum';
import { ChangeSkillStatus } from 'src/app/store/samwin/samwin-skills/samwin-skills.actions';
import { SamwinSkillsState } from 'src/app/store/samwin/samwin-skills/samwin-skills.state';
import { Skill } from 'src/app/store/samwin/samwin-skills/skill';
import { SkillGroup } from 'src/app/store/samwin/samwin-skills/skill-group';
import { SamwinUserStatusState } from 'src/app/store/samwin/samwin-user-status/samwin-user-status.state';

@Component({
   selector: 'samweb-skill-browser-mail-detail',
   templateUrl: './skill-browser-mail-detail.component.html',
   styleUrls: ['./skill-browser-mail-detail.component.scss'],
})
export class SkillBrowserMailDetailComponent implements OnInit {
   @Input()
   public treeItem: MailingSkillTreeItem;
   @Input()
   public userId;
   @Input()
   public brickInstanceId;

   public agentIcon = faUser;
   public envelopeIcon = faEnvelope;

   public isHeader: boolean;

   public mailingSkillGroup$: Observable<SkillGroup>;

   public messageCount$: Observable<number>;

   public inboxFolder: string = MailingFolderEnum.INBOX.name;

   public isCountVisible$: Observable<boolean>;

   @Select(SamwinUserStatusState.isUserLoggedOn)
   public isUserLoggedOn$: Observable<boolean>;

   constructor(public store: Store) {}

   ngOnInit(): void {
      this.isHeader = this.treeItem.skillId <= 0;
      this.mailingSkillGroup$ = this.store.select(SamwinSkillsState.getMailingSkillById).pipe(map((fn) => fn(this.treeItem.skillId, this.treeItem.groupName)));
      this.messageCount$ = this.store
         .select(SamwinMessageListStateSelectors.getMessageCount)
         .pipe(map((fn) => fn(this.treeItem.groupName, this.treeItem.skillId)));

      this.isCountVisible$ = this.messageCount$.pipe(
         switchMap((count) =>
            iif(
               () => (count > 0 && this.treeItem.groupName === MailingFolderEnum.OUTBOX.name) || this.treeItem.groupName === MailingFolderEnum.INBOX.name,
               of(true),
               of(false)
            )
         )
      );
   }

   changeSkillStatus(skills: Skill[], $event: any) {
      skills.forEach((skill) => {
         if (skill.skillUserConfiguration.isManageable) {
            this.store.dispatch(
               new ChangeSkillStatus(
                  skill.skillId,
                  $event.currentTarget.checked,
                  this.brickInstanceId,
                  SamwinSkillTypeEnum.valueOf(skill.skillConfiguration?.skillType ?? SamwinSkillTypeEnum.MAILING.value)
               )
            );
         }
      });
      return false;
   }
}
